import * as React from "react"
import './index.css'
const BlockChain = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 679 489" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m633 398 6-4"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="6.297,6.297"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m649 386 18-10"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m673.053 372 5.947-3.04-6-2.96"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="5.59,5.59"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m662 360-141-82"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m516 276-5.499-4-5.501 3.987"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="6.114,6.114"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m495 282-18 10"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m471 295-6 4M141 418l6 3"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="6.477,6.477"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m159 428 43 24"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m208 456.035 5.507 3.965 5.493-4"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="4.984,4.984"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m228 450 32-18"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m266 429 6-4m36-21 6-4"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="5.303,5.303"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m324 395 15-8"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m344.002 383 5.998-3.001-6-2.999"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="6.046,6.046"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m333 371-40-23"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m288 344-6-4m182-86 6-3m10-5.096 5.522-3.904 5.478 4"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="6.231,6.231"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m502 252 88 51"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m596 306 5.493 4 5.507-3.963"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="7.251,7.251"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m621 299 20-12"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m647 283 6-2.986-5.982-3.014"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="3.312,3.312"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m642 273-9-6"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m629 266-6-4m-222 99 6 4m-1 0 6 2.996-5.993 3.004"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="4.894,4.894"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m397 377-32 18"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="M360.952 399 355 402.036l6 2.964"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="7.041,7.041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m374 412 46 26"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m427 443 5.488 3 5.512-2.968"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="5.717000000000001,5.717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m449 436 59-33"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m513 400 6-3M94 346l-6-4"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="5.874000000000001,5.874"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m77 336-60-35"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m11 297-6-3 6-3"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="6.787,6.787"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m24 284 44-26"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m75 255 6-4m97-56 6-4"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="5.172,5.172"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m193 186 15-8"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m213 175 5.492-4 5.508 3.955"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="4.843,4.843"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m234 180 31 18"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m270 200 6 3m164-25-6 4m-8 5-5.499 4-5.501-3.995"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="4.303,4.303"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m407 182-12-7"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m390 173-6-4m24 43 9-5.63-5.308-3.37"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="4.876,4.876"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m402 198-14-8"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m384 188-6-4m-240 81 6 3.164-5.02 2.836"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="3.041,3.041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m133 273-8 5"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m122 280-6 2.974 5.966 3.026"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="5.354,5.354"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m132 292 35 20"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m172 315 5.486 4 5.514-3.933"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="4.957,4.957"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m192 310 14-8"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m212 300.933 5.516-3.933 5.484 4m7 3 6 4m265-131 6 3"
      />
      <path
        stroke="#58BAF4"
        strokeDasharray="4.276,4.276"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m515 185 12 6"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.25}
        d="m531 194 6 2.929-5.906 3.071m-1.234 2-5.86 3.105 6 2.895m1 2 6 3"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m637 385 42-24.677L511.443 263 468 287.296"
      />
      <path fill="#162272" d="M423 138v15.27L469 180l-.013-15.276z" />
      <path fill="#58BAF4" d="M469 164.724 515 138v15.274L469.013 180z" />
      <path fill="#162272" d="M423 139.499 468.5 113l45.5 26.499L468.5 166z" />
      <path
        fill="#396AEB"
        d="M472.748 171.385c0 1.779 1.442 2.389 3.218 1.361 1.782-1.028 3.221-3.302 3.221-5.083 0-1.78-1.44-2.388-3.22-1.363-1.777 1.028-3.22 3.304-3.22 5.085"
      />
      <path fill="#74FCBF" d="M481.612 164.16v4.538l27.488-15.884v-4.54z" />
      <path
        fill="#60DA9A"
        
        d="m488.83 164.526 20.27-11.712v-4.54l-20.27 11.715z"
      />
      <path
        fill="#396AEB"
        d="m238.89 214.43 26.084-14.861 25.782 14.901-25.933 14.908z"
      />
      <path fill="#162272" d="M238.89 214.43v15.13l25.626 14.947.307-15.129z" />
      <path
        fill="#58BAF4"
        d="M290.756 214.47v15.05l-26.24 14.988.307-15.129z"
      />
      <path
        fill="#162272"
        d="m290.756 119.957 51.8 29.933 51.798-29.933-51.91-27.553z"
      />
      <path
        fill="#58BAF4"
        d="M459.068 237.192v44.75L342.557 349.21l-.04-44.663z"
      />
      <path
        fill="#162272"
        d="M225.97 237.192v44.75l116.587 67.268-.039-44.663z"
      />
      <path
        fill="#396AEB"
        d="M342.518 169.84 225.97 237.194l116.548 67.354 116.55-67.354z"
      />
      <path
        fill="#396AEB"
        d="m342.518 181.707-95.906 55.424 95.906 55.425 95.909-55.425z"
      />
      <path
        fill="#60DA9A"
        
        d="m360.974 253.05-18.493 10.629-45.959-26.56 45.96-26.728 46.105 26.644z"
      />
      <path
        fill="#162272"
        d="m342.446 231.89 27.538 15.913 18.568-10.769-46.106-26.644-45.96 26.728 18.542 10.717z"
      />
      <path
        fill="#396AEB"
        d="m407.203 296.802 26.083-14.86 25.782 14.9-25.933 14.91z"
      />
      <path
        fill="#74FCBF"
        d="m342.556.217-51.8 104.771 51.8 29.935zm-51.8 119.74 51.8 29.933v74.838z"
      />
      <path
        fill="#60DA9A"
        
        d="m342.556.217 51.798 104.771-51.798 29.935zm51.798 119.74-51.798 29.933v74.838z"
      />
      <path
        fill="#162272"
        d="M407.203 296.847v15.13l25.625 14.948.307-15.13z"
      />
      <path
        fill="#58BAF4"
        d="M459.068 296.885v15.05l-26.24 14.99.307-15.128z"
      />
      <path
        fill="#396AEB"
        d="m407.203 282.347 26.083-14.86 25.782 14.901-25.933 14.908z"
      />
      <path fill="#162272" d="M407.203 282.392v15.13l25.89 14.798.042-14.98z" />
      <path
        fill="#58BAF4"
        d="M459.068 282.432v15.05l-25.976 14.837.043-14.977z"
      />
      <path
        fill="#74FCBF"
        d="m327.583 255.178 14.673-8.698 15.013 8.698-14.751 8.51z"
      />
      <path
        fill="#795EFA"
        d="m429.356 228.523 14.941-8.515 14.771 8.538-14.857 8.54z"
      />
      <path fill="#162272" d="M429.356 228.548v8.67l14.831 8.475.024-8.581z" />
      <path fill="#5647F7" d="M459.068 228.571v8.62l-14.88 8.502.023-8.581z" />
      <path
        fill="#396AEB"
        d="m342.518 254.994 14.944-8.514 14.768 8.538-14.855 8.54z"
      />
      <path fill="#162272" d="M342.518 255.02v8.668l14.831 8.477.026-8.581z" />
      <path fill="#58BAF4" d="M372.23 255.043v8.62l-14.88 8.502.025-8.582z" />
      <path
        fill="#396AEB"
        d="m254.55 229.305 14.942-8.515 14.77 8.536-14.857 8.543z"
      />
      <path fill="#162272" d="M254.55 229.33v8.668l14.832 8.477.023-8.581z" />
      <path
        fill="#58BAF4"
        d="M284.263 229.351v8.622l-14.881 8.502.024-8.582z"
      />
      <path
        fill="#795EFA"
        d="m281.035 196.688 14.942-8.514 14.768 8.536-14.855 8.542z"
      />
      <path fill="#162272" d="M281.035 196.714v8.668l14.83 8.477.025-8.581z" />
      <path fill="#5647F7" d="M310.745 196.735v8.622l-14.88 8.501.025-8.581z" />
      <path
        fill="#795EFA"
        d="m355.37 326.68 26.082-14.86 25.785 14.9-25.934 14.907z"
      />
      <path
        fill="#162272"
        d="M355.37 326.725v15.128l25.626 14.947.307-15.128z"
      />
      <path
        fill="#5647F7"
        d="M407.237 326.763v15.05l-26.24 14.988.307-15.128z"
      />
      <path
        fill="#396AEB"
        d="m238.89 304.12 26.084-14.86 25.782 14.899-25.933 14.91z"
      />
      <path
        fill="#162272"
        d="M238.89 304.164v15.13l25.626 14.948.307-15.129z"
      />
      <path
        fill="#58BAF4"
        d="M290.756 304.202v15.051l-26.24 14.99.307-15.129z"
      />
      <path fill="#162272" d="M637.644 183.583v54l-70.137-40.466.056-54.032z" />
      <path
        fill="#458FF4"
        d="m637.644 237.583-46.722 27.001-70.079-40.5 46.664-26.967"
      />
      <path
        fill="#74FCBF"
        d="m606.566 255.542-70.038-40.525 26.191-15.135 70.038 40.524zm-62.361-17.959 11.677-6.75 23.361 13.499-11.737 6.718"
      />
      <path
        fill="#396AEB"
        d="m567.563 143.086 3.474-1.863 70.622 40.485-4.015 1.876z"
      />
      <path
        fill="#162272"
        d="M641.66 181.707v57.713l-50.74 29.863v-4.7l46.725-27v-54z"
      />
      <path fill="#162272" d="M520.843 224.083v4.362l70.079 40.838v-4.7z" />
      <path
        fill="#58BAF4"
        d="M635.17 184.847v48.714l-65.191-37.567.054-48.495z"
      />
      <path
        fill="#396AEB"
        d="m588.454 158.03-18.368-10.53-.052 48.495 18.42 10.616z"
      />
      <path
        fill="#60DA9A"
        
        d="m583.932 212.158-21.212-12.275-26.193 15.137 21.08 12.195z"
      />
      <path
        fill="#58BAF4"
        d="M173.81 152.64v62.668l-3.54 2.207v-62.763zm-28.482 48.101 2.73 16.06-19.777 10.989v-3.618l15.486-8.341v-14.592z"
      />
      <path fill="#162272" d="M121.832 188.562v14.806l21.934 12.463v-14.592z" />
      <path
        fill="#162272"
        d="M94.193 110.883v62.668l32.533 18.8 43.544 25.165V154.75z"
      />
      <path
        fill="#396AEB"
        d="m94.193 110.883 3.917-1.988 75.699 43.746-3.539 2.11z"
      />
      <path
        fill="#458FF4"
        d="M95.333 112.944v59.868l31.64 18.283 42.206 24.394v-59.963z"
      />
      <path
        fill="#396AEB"
        d="m121.832 203.368-14.84 8.241 21.288 12.563 15.486-8.341z"
      />
      <path fill="#0C1445" d="M106.992 211.608v3.469l21.29 12.714v-3.618z" />
      <path
        fill="#74FCBF"
        d="M81.278 188.578 149.59 228.1l-32.814 22.393-68.032-39.317z"
      />
      <path
        fill="#60DA9A"
        
        d="m95.789 196.996-14.512-8.395-32.533 22.598 14.52 8.39z"
      />
      <path fill="#0C1445" d="M48.745 211.177v3.059l67.902 39.496v-3.239z" />
      <path
        fill="#58BAF4"
        d="m116.647 253.732 32.942-18.92V228.1l-32.942 22.394z"
      />
      <path
        fill="#396AEB"
        d="m115.8 124.747-20.468-11.803v59.868l20.469 11.829z"
      />
      <path
        fill="#162272"
        d="m198.19 99.488 36.713-21.217 2.736 1.577-.309.517c1.449 2.826 2.246 6.329 2.246 10.466 0 14.24-9.368 31.832-22.628 44.499-13.262 2.66-22.628-4.107-22.628-18.346 0-5.492 1.396-11.483 3.87-17.496"
      />
      <path
        fill="#458FF4"
        d="M237.64 79.85c2.472 3.154 3.871 7.53 3.871 13.023 0 14.24-9.369 31.83-22.628 44.499-13.262 2.657-22.629-4.107-22.629-18.348 0-5.492 1.399-11.481 3.872-17.494l37.513-21.68z"
      />
      <path
        fill="#60DA9A"
        
        d="M223.012 105.402v-2.618c-.004-.79-.21-1.186-.374-1.37a.786.786 0 0 0-.3-.21 1.383 1.383 0 0 0-.545-.095c-.473-.002-1.206.176-2.082.682-1.331.764-2.65 2.097-3.581 3.574-.94 1.472-1.473 3.088-1.46 4.252v2.618h-3.486v-2.618c.013-2.103.804-4.21 2.004-6.119 1.21-1.902 2.844-3.602 4.781-4.725 1.276-.736 2.56-1.15 3.824-1.152.642 0 1.28.113 1.874.358a4.358 4.358 0 0 1 2.134 1.901c.482.857.694 1.848.694 2.904v2.618h-3.483z"
      />
      <path
        fill="#74FCBF"
        d="M218.883 124.819c4.894-2.828 8.86-9.092 8.86-13.991v-8.086l-17.723 10.241v8.088c0 4.896 3.967 6.578 8.863 3.748"
      />
      <path
        fill="#0C1445"
        d="M219.675 111.79c1.052-.608 1.908-.247 1.908.807 0 .729-.412 1.592-1.011 2.26v3.517l-1.688.976v-3.458c-.66.078-1.118-.318-1.118-1.088 0-1.056.856-2.404 1.909-3.014"
      />
      <path
        fill="#162272"
        d="m156.841 258.87 36.714-21.218 2.739 1.58-.312.515c1.449 2.826 2.246 6.329 2.246 10.466 0 14.24-9.366 31.832-22.628 44.499-13.262 2.659-22.628-4.107-22.628-18.347 0-5.491 1.396-11.482 3.869-17.495"
      />
      <path
        fill="#458FF4"
        d="M196.293 239.231c2.473 3.155 3.87 7.53 3.87 13.024 0 14.24-9.367 31.83-22.629 44.499-13.261 2.657-22.628-4.107-22.628-18.349 0-5.491 1.399-11.48 3.872-17.493l37.515-21.68z"
      />
      <path
        fill="#60DA9A"
        
        d="M181.664 264.784v-2.618c-.002-.79-.207-1.186-.374-1.37a.77.77 0 0 0-.3-.21 1.383 1.383 0 0 0-.545-.095c-.471-.002-1.206.175-2.082.684-1.331.762-2.65 2.094-3.582 3.572-.94 1.472-1.47 3.088-1.459 4.254v2.618h-3.486l.002-2.618c.01-2.105.804-4.213 2.001-6.121 1.211-1.902 2.845-3.6 4.782-4.726 1.278-.735 2.56-1.149 3.824-1.15.642 0 1.28.112 1.876.356a4.353 4.353 0 0 1 2.132 1.902c.482.857.696 1.848.696 2.904v2.618h-3.485z"
      />
      <path
        fill="#74FCBF"
        d="M177.535 284.2c4.894-2.827 8.863-9.091 8.863-13.99v-8.086l-17.726 10.241v8.088c0 4.896 3.967 6.578 8.863 3.748"
      />
      <path
        fill="#0C1445"
        d="M178.327 271.172c1.055-.608 1.908-.247 1.908.809 0 .727-.413 1.59-1.01 2.259v3.516l-1.69.976v-3.458c-.657.078-1.117-.318-1.117-1.088 0-1.056.856-2.404 1.909-3.014"
      />
      <path
        fill="#162272"
        d="M423.435 119.842v15.116l45.79 26.462-.013-15.122z"
      />
      <path
        fill="#58BAF4"
        d="m469.212 146.297 45.777-26.455v15.12l-45.764 26.458z"
      />
      <path
        fill="#396AEB"
        d="m423.435 119.842 45.777-26.453 45.778 26.453-45.778 26.456zm49.313 32.651c0 1.778 1.442 2.388 3.218 1.363 1.782-1.03 3.221-3.304 3.221-5.085 0-1.78-1.44-2.389-3.22-1.363-1.777 1.028-3.22 3.306-3.22 5.085"
      />
      <path fill="#74FCBF" d="M481.612 145.268v4.538l27.488-15.884v-4.54z" />
      <path
        fill="#60DA9A"
        
        d="m488.83 145.634 20.27-11.712v-4.54l-20.27 11.715z"
      />
      <path
        fill="#162272"
        d="M435.58 114.547v3.638l33.663 19.324-.011-3.514z"
      />
      <path
        fill="#58BAF4"
        d="m469.233 133.995 33.655-19.447v3.812l-33.644 19.15z"
      />
      <path
        fill="#396AEB"
        d="M435.58 114.547 469.231 95.1l33.657 19.447-33.657 19.448z"
      />
      <path
        fill="#58BAF4"
        d="M158.41 377.481v15.116l-45.791 26.462.013-15.122z"
      />
      <path
        fill="#162272"
        d="M112.632 403.936 66.855 377.48v15.12l45.764 26.458z"
      />
      <path
        fill="#162272"
        d="m158.41 377.481-45.778-26.453-45.778 26.453 45.778 26.456z"
      />
      <path
        fill="#396AEB"
        d="M109.096 410.131c0 1.779-1.441 2.389-3.218 1.361-1.782-1.028-3.221-3.302-3.221-5.082 0-1.781 1.44-2.39 3.22-1.364 1.778 1.028 3.22 3.304 3.22 5.085"
      />
      <path fill="#74FCBF" d="M100.232 402.907v4.537L72.745 391.56v-4.539z" />
      <path
        fill="#60DA9A"
        
        d="m93.015 403.272-20.27-11.714v-4.537l20.27 11.714z"
      />
      <path
        fill="#58BAF4"
        d="M158.41 358.589v15.115l-45.791 26.463.013-15.123z"
      />
      <path
        fill="#162272"
        d="m112.632 385.044-45.777-26.456v15.12l45.764 26.458z"
      />
      <path
        fill="#396AEB"
        d="m158.41 358.589-45.778-26.454-45.778 26.454 45.778 26.455zm-49.314 32.65c0 1.779-1.441 2.389-3.218 1.36-1.782-1.027-3.221-3.3-3.221-5.082 0-1.78 1.44-2.388 3.22-1.363 1.778 1.028 3.22 3.304 3.22 5.085"
      />
      <path fill="#74FCBF" d="M100.232 384.015v4.537l-27.487-15.884v-4.54z" />
      <path
        fill="#60DA9A"
        
        d="m93.015 384.38-20.27-11.712v-4.54l20.27 11.715z"
      />
      <path
        fill="#396AEB"
        d="M513.572 328.271 647.76 405.82l-35.795 20.685-134.237-77.574z"
      />
      <path
        fill="#74FCBF"
        d="m620.393 410.59-115.818-66.818v-72.417l116.261 67.341z"
      />
      <path
        fill="#60DA9A"
        
        d="M504.702 312.582v31.19l115.817 66.818.19-30.967z"
      />
      <path
        fill="#FFF"
        d="M513.572 338.6s17.33-14.127 48.912 2.724c31.582 16.849 49.48-28.596 49.48-28.596v85.02l-99.511-56.775 1.12-2.373"
      />
      <path
        stroke="#396AEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M513.572 338.925s17.33-14.127 48.912 2.722c31.582 16.851 49.48-28.594 49.48-28.594"
      />
      <path
        fill="#458FF4"
        d="M614.379 314.125c0 1.333-1.081 1.791-2.415 1.021-1.333-.772-2.414-2.48-2.414-3.812 0-1.335 1.08-1.794 2.414-1.024 1.334.773 2.415 2.48 2.415 3.815m-99.511 27.458c0 1.335-1.08 1.794-2.414 1.024-1.334-.773-2.415-2.48-2.415-3.815 0-1.333 1.081-1.791 2.415-1.021 1.334.772 2.414 2.48 2.414 3.812"
      />
      <path
        fill="#162272"
        d="M477.728 348.93v10.453l134.159 77.576.078-10.453z"
      />
      <path
        fill="#58BAF4"
        d="M647.76 405.819v10.453l-35.873 20.687.076-10.453z"
      />
      <path
        fill="#162272"
        d="M146.035 338.422v-3.96l26.035-11.086 103.461 55.988v3.96l-25.897 14.968z"
      />
      <path
        fill="#396AEB"
        d="m146.035 334.462 26.035-15.046 103.461 59.948-25.897 14.966z"
      />
      <path
        fill="#74FCBF"
        d="m210.783 371.871 38.852 22.45 25.897-14.968-38.798-22.48z"
      />
      <path
        fill="#396AEB"
        d="m198.489 407.682 12.95-7.484 12.949 7.484-12.949 7.482z"
      />
      <path fill="#162272" d="M198.489 407.682v14.967l12.95 7.484v-14.969z" />
      <path fill="#58BAF4" d="M224.389 407.682v14.967l-12.949 7.484v-14.969z" />
      <path
        fill="#AA9FFB"
        d="m30.208 330.5 12.95-7.484 12.95 7.485-12.95 7.484z"
      />
      <path fill="#162272" d="M30.208 330.5v14.97l12.95 7.483v-14.968z" />
      <path fill="#795EFA" d="M56.108 330.5v14.97l-12.948 7.483v-14.968z" />
      <path
        fill="#AA9FFB"
        d="m479.15 192.086 12.949-7.484 12.95 7.484-12.95 7.484z"
      />
      <path fill="#162272" d="M479.15 192.086v14.967l12.949 7.484V199.57z" />
      <path
        fill="#795EFA"
        d="M505.05 192.086v14.967l-12.95 7.484V199.57zM329.57 466.549l12.947-7.485 12.951 7.485-12.95 7.484z"
      />
      <path fill="#162272" d="M329.57 466.549v14.968L342.516 489v-14.966z" />
      <path fill="#5647F7" d="M355.47 466.549v14.968L342.518 489v-14.966z" />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m141.29 409.054 72.058 41.175 57.885-33.45m37.699-21.787 41.015-23.702-67.848-39.154m181.581-86.443 21.555-12.06 116.207 67.157 52.109-29.758-28.995-16.755m-223.762 98.571 11.4 6.662-56.825 33.325 77.459 44.025 86.797-48.649"
      />
      <path
        fill="#162272"
        d="m473.569 367.637-36.712-21.218-2.738 1.58.309.515c-1.449 2.828-2.244 6.329-2.244 10.466 0 14.241 9.366 31.832 22.628 44.499 13.26 2.661 22.629-4.105 22.629-18.346 0-5.492-1.4-11.483-3.872-17.496"
      />
      <path
        fill="#458FF4"
        d="M434.119 347.998c-2.473 3.157-3.87 7.53-3.87 13.024 0 14.241 9.367 31.83 22.629 44.499 13.26 2.659 22.626-4.105 22.626-18.349 0-5.491-1.399-11.48-3.872-17.493l-37.513-21.68z"
      />
      <path
        fill="#60DA9A"
        
        d="M448.746 373.553v-2.62c.004-.79.21-1.186.374-1.37a.81.81 0 0 1 .3-.21c.13-.054.303-.093.545-.093.473-.004 1.208.173 2.082.682 1.331.764 2.65 2.097 3.581 3.572.94 1.474 1.473 3.09 1.46 4.254v2.618h3.486v-2.618c-.01-2.103-.804-4.213-2.004-6.121-1.21-1.9-2.844-3.6-4.781-4.726-1.276-.733-2.557-1.146-3.824-1.15-.64 0-1.28.112-1.874.356a4.358 4.358 0 0 0-2.134 1.902c-.482.857-.694 1.848-.694 2.904v2.62h3.483z"
      />
      <path
        fill="#74FCBF"
        d="M452.877 392.967c-4.896-2.828-8.863-9.092-8.863-13.99v-8.086l17.724 10.24v8.089c0 4.898-3.967 6.577-8.861 3.747"
      />
      <path
        fill="#0C1445"
        d="M452.083 379.94c-1.053-.61-1.909-.246-1.909.808 0 .727.413 1.59 1.012 2.259v3.516l1.69.978v-3.458c.658.078 1.116-.318 1.116-1.088 0-1.058-.856-2.406-1.909-3.014"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M93.95 336.793 5.748 285.82l74.759-43.2m97.82-56.533 40.282-23.28 56.774 32.318M439.54 169.84l-19.371 11.196-35.412-20.437m22.48 42.925 9.466-5.52-38.385-22.721m-240.406 79.895 6.75 3.555-28.48 16.07 61.353 35.457 39.292-22.197 19.205 11.1"
      />
      <path fill="#162272" d="M56.108 272.39 43.16 285.564l12.948 7.485z" />
      <path fill="#58BAF4" d="m56.108 272.39 12.95 13.173-12.95 7.485z" />
      <path fill="#162272" d="m644.163 293.048-12.95 13.174 12.95 7.485z" />
      <path fill="#AA9FFB" d="m644.163 293.048 12.95 13.174-12.95 7.485z" />
      <path fill="#162272" d="m271.822 152.415-12.949 13.175 12.949 7.484z" />
      <path fill="#AA9FFB" d="m271.822 152.415 12.95 13.175-12.95 7.484z" />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
        d="M452.877 407.218v18.385M177.535 298.84v11.42"
      />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M218.609 162.808v-22.175"
      />
      <path
        fill="#60DA9A"
        
        d="M9.18 288.204c-2.546 1.059-6.147.74-8.043-.711-1.896-1.454-1.368-3.488 1.178-4.549 2.547-1.06 6.146-.737 8.042.712 1.896 1.454 1.37 3.49-1.176 4.548"
      />
      <path
        fill="#58BAF4"
        d="M218.03 452.86c-2.546 1.059-6.147.74-8.043-.711-1.896-1.454-1.369-3.49 1.178-4.55 2.546-1.059 6.145-.738 8.041.713 1.896 1.454 1.37 3.49-1.176 4.549"
      />
      <path
        fill="#60DA9A"
        
        d="M353.38 373.521c-2.547 1.058-6.149.74-8.044-.714-1.896-1.452-1.369-3.488 1.178-4.548 2.546-1.058 6.148-.738 8.043.714 1.896 1.452 1.369 3.49-1.178 4.548"
      />
      <path
        fill="#58BAF4"
        d="M436.525 439.492c-2.546 1.058-6.148.74-8.044-.712-1.895-1.454-1.368-3.488 1.179-4.548 2.546-1.058 6.147-.738 8.043.711 1.896 1.454 1.368 3.49-1.178 4.549m52.921-203.248c-2.545 1.058-6.146.74-8.042-.712-1.895-1.454-1.368-3.488 1.178-4.548 2.547-1.058 6.146-.738 8.042.712 1.896 1.454 1.368 3.49-1.178 4.548"
      />
      <path
        fill="#60DA9A"
        
        d="M423.601 183.664c-2.546 1.058-6.147.74-8.043-.712-1.896-1.454-1.368-3.488 1.178-4.548 2.546-1.058 6.146-.738 8.044.712 1.895 1.454 1.368 3.49-1.179 4.548"
      />
      <path
        fill="#795EFA"
        d="m249.968 289.113 14.941-8.514 14.769 8.536-14.855 8.542z"
      />
      <path fill="#162272" d="M249.968 289.139v8.667l14.83 8.478.025-8.581z" />
      <path fill="#5647F7" d="M279.678 289.16v8.622l-14.879 8.501.024-8.581z" />
      <path
        stroke="#58BAF4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m501.29 168.074 35.402 20.1-13.262 8.022 13.573 7.484"
      />
      <path
        stroke="#396AEB"
        strokeWidth={0.25}
        d="M602.22 329.567v62.42m-21.497-47.006v34.762M563.457 342.1v27.833m-15.733-33.698v24.515m-14.572-27.367v19.196"
      />
      <path fill="#162272" d="M78.979 355.045v3.64l33.663 19.322-.01-3.512z" />
      <path
        fill="#58BAF4"
        d="m112.632 374.495 33.655-19.45v3.813l-33.644 19.15z"
      />
      <path
        fill="#396AEB"
        d="m78.979 355.045 33.653-19.447 33.657 19.447-33.657 19.45z"
      />
      <path
        fill="#60DA9A"
        
        d="M342.556.217 310.745 116.54l-19.989-11.552zm-51.8 119.74 51.8 104.771-30.088-92.224z"
      />
      <path
        fill="#74FCBF"
        d="m452.252 323.705 13.195-7.614 12.74 7.397-13.147 7.83z"
      />
      <path fill="#60DA9A"
       d="M452.252 323.705v14.96l12.968 7.514-.18-14.86z" />
      <path
        fill="#74FCBF"
        d="M478.188 323.49v15.383l-12.968 7.305-.18-14.86zM199.981 194.15l13.195-7.614 12.74 7.398-13.146 7.83z"
      />
      <path fill="#60DA9A"
       d="M199.981 194.15v14.96l12.968 7.515-.18-14.86z" />
      <path
        fill="#74FCBF"
        d="M225.917 193.935v15.384l-12.968 7.305-.18-14.86z"
      />
      <path
        fill="#60DA9A"
        
        d="m562.315 234.53-11.642 6.794-6.468-3.741 11.712-6.75z"
      />
    </g>
  </svg>
)

export default BlockChain
